import { environment } from '../../../environments/environment';

function isAbsoluteUrl(url: string): boolean {
  return /^https?:\/\//i.test(url);
}

function isChatApiPath(url: string): boolean {
  return (
    url === '/api' || url.startsWith('/api/') || url === '/health' || url.startsWith('/health/')
  );
}

function isChatAuthPath(url: string): boolean {
  return (
    url === '/session' ||
    url.startsWith('/session/') ||
    url === '/token' ||
    url.startsWith('/token/') ||
    url === '/logout' ||
    url.startsWith('/logout/') ||
    url === '/get_access' ||
    url.startsWith('/get_access/')
  );
}

function isPaymentsPath(url: string): boolean {
  return (
    url === '/options' ||
    url.startsWith('/options/') ||
    url === '/payment_info' ||
    url.startsWith('/payment_info/') ||
    url === '/payment-history' ||
    url.startsWith('/payment-history/') ||
    url === '/invoices' ||
    url.startsWith('/invoices/')
  );
}

export function resolveBackendUrl(url: string): string {
  // Keep absolute URLs intact (callers may pass full URLs).
  if (isAbsoluteUrl(url)) return url;

  // Only rewrite known backend endpoints (avoid touching assets, router URLs, etc).
  if (environment.backendMode !== 'absolute') return url;

  // All backend XHR endpoints are served by the chat API host.
  if (isChatApiPath(url) || isChatAuthPath(url)) return `${environment.chatApiBaseUrl}${url}`;
  if (isPaymentsPath(url)) return `${environment.paymentsApiBaseUrl}${url}`;

  return url;
}

export function shouldIncludeCredentialsForUrl(url: string): boolean {
  // For relative URLs, browser will include cookies automatically for same-origin fetch/XHR.
  // For absolute cross-origin requests we want credentials.
  if (environment.backendMode !== 'absolute') return false;
  return isChatApiPath(url) || isChatAuthPath(url) || isPaymentsPath(url);
}
